import React, { useState, useRef, useEffect } from 'react';
import onClickOutside from 'react-onclickoutside';
import APP_DEFAULTS from '../../../constants/app-defaults';
import { isVisibleInViewport } from '../../../helper';

// Styles
import styles from '../styles/header.scss';

const TOPBAR_HEIGHT = 130;

function DesktopMenu(props) {
    const {
        menu, closeMenu, toggleFirstMenu, toggleSecondMenu, handleClickOnStoreAndZone, currentMunicipality,
    } = props;

    const [seeAll, setSeeAll] = useState(false);
    const [secondaryMenuScrollableConfig, setSecondaryMenuScrollableConfig] = useState({
        isScrollable: false,
        maxHeight: document.documentElement.clientHeight - TOPBAR_HEIGHT,
    });
    const secondaryMenuRef = useRef(0);
    const fistLevelMenuOpen = menu ? menu.find((item) => item.type === 'first_level' && item.open) : [];
    const secondLevelMenuOpen = fistLevelMenuOpen !== undefined ? fistLevelMenuOpen.items.find((item) => item.type === 'second_level' && item.open) : undefined;

    useEffect(() => {
        if (secondLevelMenuOpen && secondaryMenuRef.current !== 0) {
            if (!isVisibleInViewport(secondaryMenuRef.current)) {
                setSecondaryMenuScrollableConfig({
                    ...secondaryMenuScrollableConfig,
                    isScrollable: true,
                });
            }
        }
    }, [secondLevelMenuOpen, secondaryMenuScrollableConfig]);

    DesktopMenu.handleClickOutside = () => {
        closeMenu();
    };

    const secondLevelHtmlMarkup = secondLevelMenuOpen === undefined
        ? null
        : (
            <ul
                className={`${styles.secondLevelMenu2} ${secondaryMenuScrollableConfig.isScrollable && styles.scrollable}`}
                ref={secondaryMenuRef}
                style={{ maxHeight: secondaryMenuScrollableConfig.isScrollable ? secondaryMenuScrollableConfig.maxHeight : '' }}
            >
                {secondLevelMenuOpen.items.map((subitem) => (
                    <li key={subitem.id} className="pe-1x pe-va font-weight-bold" style={{ paddingTop: '3px', paddingBottom: '3px' }}>
                        <a
                            className="line-double"
                            onClick={() => handleClickOnStoreAndZone(secondLevelMenuOpen.id, subitem.id)}
                            style={{ fontWeight: 'bold', paddingTop: '3px', paddingBottom: '3px' }}
                        >
                            {subitem.label}
                        </a>
                    </li>
                ))}
            </ul>
        );
    return (
        <ul className="nav navbar-nav">
            {/* eslint-disable-next-line array-callback-return */}
            {menu.map((firstLevelMenu) => {
                if (firstLevelMenu.type === 'link') {
                    return (
                        <li
                            key={`L${firstLevelMenu.id}`}
                            className={styles['header__menu-item']}
                            style={{ borderRight: `1px solid ${APP_DEFAULTS.theme.mainManeDividerColor}` }}
                            onClick={() => handleClickOnStoreAndZone(undefined, firstLevelMenu.id)}
                        >
                            <a>{firstLevelMenu.label}</a>
                        </li>
                    );
                } if (firstLevelMenu.type === 'first_level') {
                    return (
                        <li key={`FL${firstLevelMenu.id}`} className="dropdown" style={{ borderRight: `1px solid ${APP_DEFAULTS.theme.mainManeDividerColor}` }}>
                            <a
                                className={`dropdown-toggle line-double ${firstLevelMenu.open ? styles.rootMenuSelect : ''} font-weight-bold`}
                                data-toggle="dropdown"
                                onClick={() => toggleFirstMenu(firstLevelMenu.id)}
                                style={{ color: APP_DEFAULTS.theme.mainMenuDropdownColor, display: 'inline-block' }}
                            >
                                {firstLevelMenu.label}
                                {currentMunicipality ? ` - ${currentMunicipality.name}` : ' '}
                                <i
                                    className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleDown}`}
                                    style={{ display: firstLevelMenu.open ? 'none' : 'inline-block' }}
                                />
                                <i
                                    className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`}
                                    style={{ display: firstLevelMenu.open ? 'inline-block' : 'none' }}
                                />
                            </a>
                            <ul className={`dropdown-menu ${styles.menu} ${styles.firstLevelMenu}`} style={{ display: firstLevelMenu.open ? 'block' : 'none' }}>
                                {firstLevelMenu.items.map((item) => (
                                    <li key={`I${item.id}`} className="dropdown">
                                        <a
                                            className="dropdown-toggle line-double"
                                            data-toggle="dropdown"
                                            style={{ color: item.open ? APP_DEFAULTS.theme.desktopItemOpenColor : 'white', display: 'inline-block' }}
                                            onClick={() => toggleSecondMenu(firstLevelMenu.id, item.id)}
                                        >
                                            {item.label}
                                            {' '}
                                            <i
                                                className={`pe-7s-angle-left pe-1x pe-va font-weight-bold ${styles.angleUp} ${styles.navigationIcon} ${item.open ? styles.open : ''}`}
                                            />
                                        </a>
                                    </li>
                                ))}
                                {secondLevelHtmlMarkup}
                            </ul>
                        </li>
                    );
                }
            })}
        </ul>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => DesktopMenu.handleClickOutside,

};

export default onClickOutside(DesktopMenu, clickOutsideConfig);



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/desktop-menu.jsx
 **/